export enum LevelType {
  Reading = 'Reading',
  Video = 'Video',
  Quiz = 'Quiz',
  LiveSession = 'LiveSession',
  Exam = 'Exam',
  Assignment = 'Assignment',
}
